<template>
  <v-sheet width="100%">
    <v-snackbar top timeout="1500" color="success" v-model="snackbar">Copied to Clipboard</v-snackbar>
    <v-card-title primary-title>
      <div class="headline">
        iFrame Link
      </div>
    </v-card-title>
    <v-card-text>
      <v-alert outline v-if="!isLinked" type="info" :value="true">
        iFrame URL will be available when this question is linked to QuestionMark.
      </v-alert>
      <v-text-field readonly outlined hide-details dense
                    append-icon="mdi-content-copy"
                    @click:append="handleCopy"
                    v-if="isLinked" v-model="iframeLink"></v-text-field>
    </v-card-text>
  </v-sheet>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'

  export default {
    name: 'QuestionIframe',

    data() {
      return {
        copyStatus: null,
        snackbar: false
      }
    },

    computed: {
      ...mapGetters(['getNewQuestion', 'GET_API_KEY']),
      isLinked() {
        return this.getNewQuestion.linked_id && this.getNewQuestion.linked_id !== ""
      },
      copySuccess() {
        if (this.copyStatus === 'notcopied')
          return 'primary'

        if (this.copyStatus === 'true')
          return 'success';

        if (this.copyStatus === 'false')
          return 'error';
      },
      iframeLink() {
        let start = JSON.parse(this.getNewQuestion.startpoint);
        let end = JSON.parse(this.getNewQuestion.endpoint);
        console.dir(start)
        console.dir(end)
        return "<iframe class='geoxphere' id='geoxphere_" + this.getNewQuestion.linked_id + "' src='" + process.env.VUE_APP_BASE_URL + "/assess?user=" + this.GET_API_KEY + "&start=" + start.geometry.coordinates.toString() + "&end=" + end.geometry.coordinates.toString() + "&linked_id=" + encodeURIComponent('geoxphere_' + this.getNewQuestion.linked_id) + "'/>"
      }
    },

    methods: {
      handleCopy(clip) {
        this.$copyText(this.iframeLink).then(() => {
          this.snackbar = true
        })
      },
      handleCopyError() {
        this.copyStatus = false
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
